// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  
  .spinner {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 6px solid transparent;
    border-top-color: #3498db; /* Change the color of the spinner */
    animation: spin 1s linear infinite;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1); /* Add a subtle shadow effect */
  }
  
  .loading-text {
    margin-top: 20px;
    font-size: 24px;
    color: #555; /* Change the color of the text */
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Loading.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB,EAAE,oCAAoC;IAC/D,kCAAkC;IAClC,uCAAuC,EAAE,+BAA+B;EAC1E;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW,EAAE,iCAAiC;EAChD;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF","sourcesContent":[".loading-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n  }\n  \n  .spinner {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    border: 6px solid transparent;\n    border-top-color: #3498db; /* Change the color of the spinner */\n    animation: spin 1s linear infinite;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1); /* Add a subtle shadow effect */\n  }\n  \n  .loading-text {\n    margin-top: 20px;\n    font-size: 24px;\n    color: #555; /* Change the color of the text */\n  }\n  \n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
